module.exports = __webpack_public_path__ + "img/黑桃中级大师@2x.493c0bfd.png";